module.exports = __webpack_public_path__ + "static/giphysdk-promo-9baa94b32412a1157d68dc58b82fd28f.gif";